import React, { useEffect, useState } from 'react'
import { faAngleUp } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useDtmAnalytics } from 'hooks/useDtmAnalytics'
import { AnalyticsStore, DtmPageName } from 'utils/analyticsUtils'
import { StyledScrollButton } from './ScrollButton.styled'

const ScrollButton = () => {
  const [show, setShow] = useState(false)
  const { userInteraction } = useDtmAnalytics()

  useEffect(() => {
    const toggleVisible = () => {
      const scrolled = document.documentElement.scrollTop
      if (scrolled > 300) {
        setShow(true)
      } else if (scrolled <= 300) {
        setShow(false)
      }
    }
    window.addEventListener('scroll', toggleVisible)

    return () => window.removeEventListener('scroll', toggleVisible)
  }, [])

  const scrollToTop = () => {
    // This component is also mounted on VDP (via VehicleDetailsPage) — only fire the
    // SRP-specific legacy tag when actually on the Search Results Page.
    if (AnalyticsStore.pageName === DtmPageName.SRP) {
      userInteraction('am:rmsus/search results page/search results page:root:TOP')
    }
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  return (
    <StyledScrollButton className="d-print-none" onClick={scrollToTop} show={show}>
      <div className="circle">
        <FontAwesomeIcon icon={faAngleUp}></FontAwesomeIcon>
      </div>
      <span>TOP</span>
    </StyledScrollButton>
  )
}

export default ScrollButton
